export default __webpack_public_path__ + "static/media/우체국.d928116b.svg";